import React from "react";

export type CollegeProfileSectionHeaderProps = {
  title: string;
  children?: React.ReactNode;
};

/**
 * Shared title row for College profile sections: a section heading with
 * optional trailing actions (edit controls, "Sync email types", etc).
 * Purely presentational — sections own their own actions/logic.
 */
const CollegeProfileSectionHeader = ({ title, children }: CollegeProfileSectionHeaderProps) => (
  <div className="flex items-center justify-between gap-3">
    <h3 className="text-xl font-bold text-navy-800">{title}</h3>
    {children && <div className="flex items-center gap-3">{children}</div>}
  </div>
);

export default CollegeProfileSectionHeader;
